import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ModuleService } from '../module.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-appointment',
  templateUrl: './add-appointment.component.html',
  styleUrls: ['./add-appointment.component.scss']
})
export class AddAppointmentComponent {
  appt_form: FormGroup;

  breadCrumbItems: Array<{}>;
  data: any;
  patient_id: any;
  today: any;
  datare: any;
  now: any;
  doctordata: any;
  loadingpart: boolean = false;
  phone_number: any;
  id: any;
  editForm: FormGroup;
  table: any;


  constructor(
    public formBuilder: UntypedFormBuilder,
    private myservice: ModuleService,
    public modalService: NgbModal,
    public route: ActivatedRoute,
    private router: Router,
    public datePipe: DatePipe) {
    this.appt_form = this.formBuilder.group({
      salutation: [""],
      name: ["", [Validators.required]],
      last_name: ["", [Validators.required]],
      age: ["", [Validators.required]],
      phone_number: ["", [Validators.required]],
      dob: ["", [Validators.required]],
      gender: ["", [Validators.required]],
      occupation: [""],
      guardian: [""],
      aadhar: [""],
      address: [""],
      alt_number: [""],
      patient_type: [""],
      // pymnt_mode: [""],
      appointment_date: new FormControl(
        new Date().toISOString().substring(0, 10)
      ),
      time_slot: ["", [Validators.required]],
      days_to_expiry: ["", [Validators.required]],
      expiry_date: [""],
      amount: ["", [Validators.required]],
      doctor_name: ["", [Validators.required]],
      department_name: ["", [Validators.required]],
      problem: ["", [Validators.required]],
      infosource: [""],
      pymnt_type: ["", [Validators.required]],
      upiId: [""],
      // netBanking: [""],
      // cardNumber: [""],
      // expiryDate: [""],
      // cvv: [""],
      discount: ["0"],

    });

    this.editForm = this.formBuilder.group({
      salutation: [""],
      name: [""],
      last_name: [""],
      age: [""],
      phone_number: [""],
      gender: [""],
      appointment_date: new FormControl(
        new Date().toISOString().substring(0, 10)
      ),
      time_slot: [""],
      days_to_expiry: [""],
      expiry_date: [""],
      amount: [""],
      discount: ["0%"]
    })

    this.getappointmentdata();
    this.today = new Date();
    this.now = datePipe.transform(new Date(), 'yyyy-MM-dd');

  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Godavari wave Tech' },
      { label: 'Add - Appointment', active: true }
    ];

    var data = {
      company_id: localStorage.getItem('company_id')
    }
    this.myservice.adddoctorreports(data).subscribe((res: any) => {
      this.doctordata = res.data
    })
  }

  getdep(evrnt) {

    var result = this.doctordata.find(o => o.doctor_name === evrnt);


    this.appt_form.patchValue({
      department_name: result.doctor_dept
    })


  }

  typesubmit: boolean;
  get type() {
    return this.appt_form.controls;
  }

  gotoprescriptionlist() {
    this.router.navigate(['/hospital/appointment-list']);
  }

  // Accept Input As a Number Only
  numericOnly(event): boolean {
    let patt = /^([0-9])$/;
    let result = patt.test(event.key);
    return result;
  }

  getappointmentdata() {
    this.myservice.gettodayappointments().subscribe((res: any) => {
      this.data = res.data;
      this.changeFn();
    });
  }

  onPhoneNumberChange(event: any) {
    const phonenumber = event.target.value;
    console.log('Phone number entered:', phonenumber);

    // Fetch the data and find matching patient details
    this.myservice.getappointments().subscribe((res: any) => {
      this.data = res.data;
      // console.log('Fetched data:', this.data);

      // this.data.forEach(patient => {
      //   console.log('Patient object:', patient);
      //   console.log('Patient phone_number field:', patient.number);      
      // });

      // Only after the data is fetched, find the patient and patch the form
      const patientData = this.data.find(patient => {
        const patientPhoneNumber = patient.number;         // Ensure patient phone number is trimmed
        // console.log('Comparing:', patientPhoneNumber, 'with entered number:', phonenumber);
        return patientPhoneNumber === phonenumber;
        // console.log(patientData);
      });

      if (patientData) {
        console.log('Matching patient data found:', patientData);
        this.appt_form.patchValue({
          salutation: patientData.salutation,
          name: patientData.name,
          last_name: patientData.last_name,
          age: patientData.age,
          gender: patientData.gender,
          dob: patientData.dob,
          patient_type: 'Old Patient'

        });
      } else {
        console.log('No matching patient found');

        this.appt_form.patchValue({
          patient_type: 'New Patient'

        });
      }
    });
  }


  changeFn() {
    const search = this.now;
    this.data = this.data.filter(obj => {
      return !!JSON.stringify(Object.values(obj)).match(new RegExp(search, 'i'));
    });
  }

  typeSubmit() {
    this.loadingpart = true;
    this.typesubmit = true;
    if (this.appt_form.invalid) {
      this.loadingpart = false;
      return;
    } else {

      this.appt_form.value.company_id = localStorage.getItem('company_id');

      var DAYS = this.appt_form.value.days_to_expiry;
      var today = new Date().toLocaleDateString();
      this.appt_form.value.date = today;
      var date = new Date();
      date.setDate(date.getDate() + DAYS * 1);
      this.appt_form.value.expiry_date = date.toLocaleDateString();
      
      

      console.log(this.appt_form.value);
      this.myservice.Add_appointment(this.appt_form.value).subscribe((res: any) => {
        if (res.status == 200) {
          this.loadingpart = false;
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Successfully Submitted',
            showConfirmButton: false,
            timer: 1500
          });
          this.typesubmit = false;
          this.appt_form.reset();
          this.getappointmentdata();
        } else {
          Swal.fire('Failed');
        }
      })
    }
  }

  reset() {
    this.appt_form.reset();
  }

  printData(data) {
    sessionStorage.setItem('appointmentprint', JSON.stringify(data))
    this.router.navigate(['appointmentprint']);
  }


  centerModal(centerDataModal: any, data) {
    this.editForm.patchValue({
      appointment_date: data.appointment_date,
      time_slot: data.time_slot,
      salutation: data.salutation,
      name: data.name,
      last_name: data.last_name,
      age: data.age,
      gender: data.gender,
      phone_number: data.number,
      days_to_expiry: data.days_to_expiry,
      amount: data.amount,
      discount: data.discount,
      // id: data.id,
    });
    this.id = data.id;
    this.modalService.open(centerDataModal, { centered: true, size: "lg" });
  }

  edit() {
    this.typesubmit = true;
    if (this.editForm.invalid) {
      alert("Please fill all details");
      return;
    } else

    
    var DAYS = this.editForm.value.days_to_expiry;
    var today = new Date().toLocaleDateString();
    this.editForm.value.date = today;
    var date = new Date();
    date.setDate(date.getDate() + DAYS * 1);
    this.editForm.value.expiry_date = date.toLocaleDateString();

      var data = {
        company_id: localStorage.getItem("company_id"),
        id: this.id,
        appointment_date: this.editForm.value.appointment_date,
        time_slot: this.editForm.value.time_slot,
        salutation: this.editForm.value.salutation,
        name: this.editForm.value.name,
        last_name: this.editForm.value.last_name,
        age: this.editForm.value.age,
        gender: this.editForm.value.gender,
        number: this.editForm.value.phone_number,
        days_to_expiry: this.editForm.value.days_to_expiry,
        amount: this.editForm.value.amount,
        discount: this.editForm.value.discount,
        expiry_date: this.editForm.value.expiry_date

      };

      this.myservice.Editappointment(data).subscribe((res: any) => {
      console.log(data);
      
      if (res.status == 200) {
        this.getappointmentdata();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Successfully Updated",
          showConfirmButton: false,
          timer: 1500,
        });
        this.typesubmit = false;
        this.editForm.reset();
        this.modalService.dismissAll();
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Oops...",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  }

  Delete(i) {
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure to delete it ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.myservice.deleteappointments(i).subscribe((res: any) => {
          if (res.status == 200) {
           this.getappointmentdata();
            ;
            Swal.fire({
              position: "top-end",
              title: "Deleted!",
              text: "Your file has been deleted.",
              icon: "success",
            });
          }
        });
      }
    });
  }

  
  upi: boolean = false;
  card: boolean = false;
  netBanking: boolean = false;

  selectfield(event) {
    // console.log(event);
    if (event == 'upi') {
      this.upi = true
      this.netBanking = false
      this.card = false
    } else if (event == 'card') {
      this.upi = false
      this.netBanking = false
      this.card = true
    } else if (event == 'netBanking') {
      this.upi = false
      this.netBanking = true
      this.card = false
    } else {
      this.upi = false
      this.netBanking = false
      this.card = false
    };

  }
}

